import { type FormEvent, useEffect, useState } from "react";
import { Link } from "react-router";

import { type ProposalRow, listProposals, message } from "./studioClient";

/** Mapping proposals of an engagement: what was proposed, and what was decided. */
export function MappingStudioPage() {
  const [filter, setFilter] = useState<{ engagement: string; undecided: boolean } | null>(null);
  const [found, setFound] = useState<ProposalRow[] | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!filter) return undefined;
    let live = true;
    listProposals(filter.engagement, filter.undecided)
      .then((rows) => {
        if (live) {
          setFound(rows);
          setError(null);
        }
      })
      .catch((caught: unknown) => {
        if (live) setError(message(caught));
      });
    return () => {
      live = false;
    };
  }, [filter]);

  function onFilter(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    const form = new FormData(event.currentTarget);
    setFilter({
      engagement: String(form.get("engagement") ?? "").trim(),
      undecided: form.get("undecided") === "on",
    });
  }

  return (
    <section aria-labelledby="studio-title">
      <h1 id="studio-title">Mapping Studio</h1>
      <form onSubmit={onFilter} aria-label="Proposal filters">
        <label>
          Engagement id <input name="engagement" required />
        </label>
        <label>
          <input type="checkbox" name="undecided" /> Undecided only
        </label>
        <button type="submit">Show proposals</button>
      </form>
      {error && <p role="alert">Could not load proposals: {error}</p>}
      {found?.length === 0 && <p>No proposals match.</p>}
      {found && found.length > 0 && (
        <table aria-label="Proposals">
          <thead>
            <tr>
              <th>Concept</th>
              <th>Proposed target</th>
              <th>Outcome</th>
              <th>Existing mapping</th>
              <th>Decision</th>
            </tr>
          </thead>
          <tbody>
            {found.map((row) => (
              <tr key={row.id}>
                <td>{row.concept_key ?? "No certified concept"}</td>
                <td>
                  <Link to={`/mapping-studio/${row.id}`}>
                    {row.target_object
                      ? `${row.target_object}.${row.target_attribute ?? ""}`
                      : "No target proposed"}
                  </Link>
                </td>
                <td>{row.outcome}</td>
                <td>{row.certified_mapping_exists ? "Yes" : "No"}</td>
                <td>{row.decision ?? "Undecided"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </section>
  );
}
